import { useState, useEffect } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { Dialog } from "primereact/dialog";
import { v4 as uuidv4 } from 'uuid';
import { getFirestore, writeBatch, doc } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD2xHbRS0x4ba0WHY7foYtIAPa3SMyBkIk",
    authDomain: "srkay-insights-f2858.firebaseapp.com",
    projectId: "srkay-insights-f2858",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const UserFinanace = ({ showPopUp, setShowPopUp }) => {
    const [token, setToken] = useState("");
    const [data, setData] = useState([]);
    const [inputValues, setInputValues] = useState({});

    const projectId = "srkay-insights-f2858";
    const collection = "Userfinance";

    // Login and get token
    const login = async () => {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, "ritesh.khatri@srkay.com", "Radha@87");
            const user = userCredential.user;
            const idToken = await user.getIdToken();
            setToken(idToken);
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    // Fetch data from Firestore REST API
    const fetchData = async () => {
        try {
            const res = await fetch(
                `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/${collection}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const json = await res.json();
            const docs = json.documents?.map(doc => ({
                id: doc.name.split("/").pop(),
                ...Object.fromEntries(
                    Object.entries(doc.fields).map(([key, value]) => [key, Object.values(value)[0]])
                ),
            })) || [];
            setData(docs);
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

 

    const addMultipleDocumentsFirestoreSDK = async () => {
        if (!token) {
             alert("Admin must be logged in");
            return;
        }

        const batch = writeBatch(db);
        const docs = [
            { employeeId: "E0011", name: "John Doe" },
            { employeeId: "E0021", name: "Jane Smith" },
            { employeeId: "E0031", name: "Alice Johnson" },
            { employeeId: "E0041", name: "Bob Brown" }
        ];

        docs.forEach(docData => {
            const docRef = doc(db, "Userfinance", uuidv4());
            batch.set(docRef, docData);
        });

        try {
            await batch.commit();
            console.log("Batch write successful via Firestore SDK");
            fetchData();
        } catch (error) {
            console.error("Batch write failed:", error);
        }
    };

    const createDocument = async () => {
        try {
            await fetch(
                `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/${collection}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        fields: {
                            employeeId: { stringValue: inputValues?.employeeId },
                            name: { stringValue: inputValues?.name },
                        },
                    }),
                }
            );
            setInputValues({});
            fetchData(); // Refresh data
        } catch (error) {
            console.error("Add error:", error);
        }
    };

    useEffect(() => {
        if (token) {
            fetchData();
        }
    }, [token]);

    return (
        <div>
            <Dialog className='modal-xsmall' visible={showPopUp} onHide={() => setShowPopUp(false)} draggable={false} header="Add User Finance">

                <button onClick={login}>Login</button>
                <button onClick={addMultipleDocumentsFirestoreSDK}>Add</button>

                {token && (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    onChange={(e) =>
                                        setInputValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
                                    }
                                    value={inputValues.name}
                                    className="input-text w-100"
                                />
                            </div>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="employeeId"
                                    placeholder="Employee Id"
                                    onChange={(e) =>
                                        setInputValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
                                    }
                                    value={inputValues.employeeId}
                                    className="input-text w-100"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-end my-2">
                            <button onClick={createDocument}>
                                Submit
                            </button>
                        </div>
                        <ul>
                            {data.map(doc => (
                                <li key={doc.id}>{doc.name}</li>
                            ))}
                        </ul>
                    </>
                )}
            </Dialog>

        </div>
    );
};

export default UserFinanace;
